import { Component, Input, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { IExercice } from 'src/app/users/src/users.model';
import { DataHelper, DialogService } from 'src/app/core';
import { TrainingFormDialog } from '../dialog/training-form/training-form';

@Component({
	selector: 'training-list',
	templateUrl: 'training-list.html',
	styleUrls: ['training-list.scss']
})
export class TrainingList implements OnInit {
	@Input('training') exercice: IExercice;
	@Input('user_id') user_id: IExercice;
	constructor(private dialog: DialogService) { }

	ngOnInit() {

	}
	ngOnChanges() {
	}
	add() {
		this.dialog.openDialog(TrainingFormDialog, {
			user_id: this.user_id
		});
	}




}


@Component({
	selector: 'training-list-item',
	templateUrl: 'training-list-item.html',
	styleUrls: ['training-list.scss']
})
export class TrainingListItem implements OnInit {
	@Input('item') item;
	@Input('exercice') exercice;
	@ViewChild('weight') weight: ElementRef;
	constructor(private rend: Renderer2,
		private dialogService: DialogService) { }
	ngOnInit() {
	}
	ngAfterViewInit() {
		this._resolveClass();
	}
	private getMax(property: string, target: string) {
		let data = this.exercice
		data = JSON.parse(JSON.stringify(data));
		return Math.max.apply(Math, data.filter(exo => exo['exercice_id'] == target).map(function(o) { return o[property]; }))
	}

	private _resolveClass() {
		let itemId = this.item.id
		let exercice = this.exercice.filter(exo => exo.exercice_id == this.item.exercice_id);
		let i = exercice.findIndex(exo => exo.id == itemId);
		let c;
		if (i < exercice.length - 1) {
			let itemWeight = parseInt(this.item.weight)
			let parentItemWeith = parseInt(exercice[i + 1].weight)
			if (parentItemWeith < itemWeight)
				c = 'up'
			if (parentItemWeith == itemWeight)
				c = "egal"
			if (parentItemWeith > itemWeight)
				c = "down"

		}
		this.rend.addClass(this.weight.nativeElement, c);

	}

	private _update() {
		console.log(this.item)
		this.dialogService.openDialog(TrainingFormDialog, this.item);
	}
}
